import React from "react";
import LegalLayout from "@/components/LegalLayout";
import { useLang } from "@/lib/i18n";

export default function Imprint() {
  const { t, lang } = useLang();
  return (
    <LegalLayout title={t("legal.imprint.title")} updated={t("legal.imprint.updated")} testid="imprint-page" path="/impressum">
      {lang === "de" ? <De /> : <En />}
    </LegalLayout>
  );
}

const De = () => (
  <>
    <h2>Angaben gemäß § 5 DDG</h2>
    <p>
      X10 Management GmbH<br />
      Herner Str. 299<br />
      44809 Bochum<br />
      Deutschland
    </p>

    <h2>Vertreten durch</h2>
    <p>Geschäftsführer: Dipl. Bw. Cengiz Kosan</p>

    <h2>Kontakt</h2>
    <p>
      Telefon: +49 234 6055 0<br />
      E-Mail: <a href="mailto:kontakt@x10management.de">kontakt@x10management.de</a>
    </p>

    <h2>Registereintrag</h2>
    <p>
      Eintragung im Handelsregister.<br />
      Registergericht: Amtsgericht Bochum<br />
      Registernummer: HRB 22322
    </p>

    <h2>Umsatzsteuer-ID</h2>
    <p>
      Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
      DE45252125216859
    </p>

    <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
    <p>
      Dipl. Bw. Cengiz Kosan<br />
      Herner Str. 299<br />
      44809 Bochum
    </p>

    <h2>EU-Streitschlichtung</h2>
    <p>
      Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
      <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noreferrer">https://ec.europa.eu/consumers/odr/</a>.<br />
      Unsere E-Mail-Adresse finden Sie oben im Impressum.
    </p>

    <h2>Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
    <p>
      Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
      Verbraucherschlichtungsstelle teilzunehmen.
    </p>

    <h2>Haftung für Inhalte</h2>
    <p>
      Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen
      Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind
      wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte
      fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
      rechtswidrige Tätigkeit hinweisen.
    </p>

    <h2>Haftung für Links</h2>
    <p>
      Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir
      keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine
      Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige
      Anbieter oder Betreiber der Seiten verantwortlich.
    </p>

    <h2>Urheberrecht</h2>
    <p>
      Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
      unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung,
      Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts
      bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
    </p>
  </>
);

const En = () => (
  <>
    <h2>Information according to § 5 DDG</h2>
    <p>
      X10 Management GmbH<br />
      Herner Str. 299<br />
      44809 Bochum<br />
      Germany
    </p>

    <h2>Represented by</h2>
    <p>Managing Director: Dipl. Bw. Cengiz Kosan</p>

    <h2>Contact</h2>
    <p>
      Phone: +49 234 6055 0<br />
      Email: <a href="mailto:kontakt@x10management.de">kontakt@x10management.de</a>
    </p>

    <h2>Commercial Register</h2>
    <p>
      Register entry.<br />
      Register court: Local Court of Bochum<br />
      Register number: HRB 22322
    </p>

    <h2>VAT ID</h2>
    <p>
      VAT identification number according to § 27 a German VAT Act:<br />
      DE45252125216859
    </p>

    <h2>Responsible for content according to § 18 (2) MStV</h2>
    <p>
      Dipl. Bw. Cengiz Kosan<br />
      Herner Str. 299<br />
      44809 Bochum
    </p>

    <h2>EU dispute resolution</h2>
    <p>
      The European Commission provides a platform for online dispute resolution (OS):{" "}
      <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noreferrer">https://ec.europa.eu/consumers/odr/</a>.
    </p>

    <h2>Consumer dispute resolution</h2>
    <p>We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board.</p>

    <h2>Liability for content</h2>
    <p>
      As a service provider we are responsible for our own content on these pages
      according to general laws under § 7 (1) DDG. However, according to §§ 8 to 10
      DDG, we are not obliged to monitor transmitted or stored third-party information.
    </p>

    <h2>Liability for links</h2>
    <p>
      Our website contains links to external websites of third parties whose content we have no control over.
    </p>

    <h2>Copyright</h2>
    <p>
      The content and works created by the site operators on these pages are subject to German copyright law.
    </p>
  </>
);
